export const passwordSpecialCharRegex = /[!@#$%^&*(),.?":{}|–<>-]/;
export const passwordLowerCaseRegex = /[a-z]/;
export const passwordUpperCaseRegex = /[A-Z]/;
export const passwordNumberRegex = /\d/;
